import React from 'react';
import { useIsIE } from '../../hooks/useIsIE';
import { Picture, PictureProps } from '../html5/Picture';

interface BackgroundPictureProps extends PictureProps {
    className?: string;
    pictureClassName?: string;
    allowOverflow?: boolean;
}

const BackgroundPicture: React.FC<BackgroundPictureProps> = ({
    children,
    className = '',
    pictureClassName = '',
    allowOverflow = false,
    ...pictureProps
}) => {
    const isIE = useIsIE();
    className = `${className} ${isIE ? 'bg-picture-ie' : 'bg-picture'} d-flex ${
        allowOverflow ? '' : 'overflow-hidden'
    } position-relative`.trim();

    if (isIE) {
        // Note: Internet Explorer does not support .webp or the `object-fit` css property, so we use a css
        // background instead of using the Picture component. This means we lose the fallback to the default
        // image on error, and the altText (not strictly necessary for a background image).
        return (
            <div
                className={className}
                data-testid="bg-picture-ie"
                style={{ backgroundImage: `url(${pictureProps.url})` }}
            >
                {children}
            </div>
        );
    }

    return (
        <div className={className}>
            <Picture {...pictureProps} className={`${pictureClassName} h-100 w-100 position-absolute`.trim()} />
            {children}
        </div>
    );
};

export { BackgroundPicture, BackgroundPictureProps };
